<div *ngIf="saveSuccessfullyMsg" class="print-history-popup">
    <div class="print-history-popup-body">
      <h2 class="popup-title">Saved successfully </h2>
      <button
        (click)="saveSuccessfullyMsg = false"
        class="print-history-popup-close"
        aria-label="close popup"
      ></button>
    </div>
  </div>
<div class="wrapper">
    <div class="m-box">
      <h2>Sms Settings</h2>
      <form [formGroup]="smsForm" (ngSubmit)="onSubmit()">
        <div style="display: flex; flex-direction: column; gap: 1em; align-items: flex-start;">
          <div>
            <label>Clinic address:</label>&nbsp;
            <input style="width: 25em;" class="t-field menstural-field" formControlName="Address" />
          </div>
          <div>
            <label>Waze link:</label>&nbsp;
            <input style="width: 25em;" class="t-field menstural-field" formControlName="wazeLink" />
          </div>
          <div>
            <label>Link to additional instructions:</label>&nbsp;
            <input style="width: 25em;" class="t-field menstural-field" formControlName="instructionsLink" />
          </div>
          <div>
            <label>Clinic phone number:</label>&nbsp;
            <input style="width: 25em;" class="t-field menstural-field" formControlName="phone" />
          </div>
          <button class="orange-btn" matTooltip="save changes" type="submit">Save</button>
        </div>
      </form>
    </div>
  </div>
  